import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./translations/en";
import { fr } from "./translations/fr";



const defaultLocale = "fr";

const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("i18nLocaleKey") || defaultLocale,
    fallbackLng: ["fr", "en"],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    saveMissing: true, // send not translated keys to endpoint
    returnNull: false,
  });

export default i18n;
